import { useState, useEffect } from 'react';
import { fetchBookRating } from '../services/hardcover';

const cache = new Map();

export function useBookRating(book) {
  const [rating, setRating] = useState(undefined); // undefined = loading, null = no data

  const bookKey = book?.key;
  const title   = book?.title;
  const author  = book?.author;

  useEffect(() => {
    if (!title) { setRating(null); return; }
    if (cache.has(bookKey)) { setRating(cache.get(bookKey)); return; }

    setRating(undefined);
    fetchBookRating(title, author).then(result => {
      cache.set(bookKey, result);
      setRating(result);
    });
  }, [bookKey, title, author]);

  return rating; // { rating, ratingsCount } | null | undefined
}
